/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hierarchy'
export default icon
